import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../App";
import useAdminOrganizations from "../hooks/useAdminOrganizations";
import { legacyToAdminPortalPath } from "../utils/adminPortalRollout";
import { getMainAppUrl, getSubdomain, isWebsiteProHost, websiteProOrganizationSlug } from "../utils/subdomain";

// Resolve membership before mounting any old /admin page. Rollout preferences and
// legacy=1 are no longer alternative organization experiences.
export default function OrganizationAdminRedirect() {
  const { user } = useAuth();
  const location = useLocation();
  const membership = useAdminOrganizations();
  const subdomain = getSubdomain() || websiteProOrganizationSlug();
  const crossHost = Boolean(subdomain) || isWebsiteProHost();
  const [error, setError] = useState(false);
  const organization = membership.organizations.find((item) => item.org_id === user?.org_id && (!subdomain || item.subdomain === subdomain));
  const destination = organization ? `${legacyToAdminPortalPath(location.pathname, organization.subdomain, location.search)}${location.hash}` : null;
  useEffect(() => {
    if (!organization || !destination) return;
    let active = true;
    const enter = async () => {
      try {
        if (active && crossHost) window.location.replace(new URL(destination, getMainAppUrl()).toString());
      } catch { if (active) setError(true); }
    };
    enter();
    return () => { active = false; };
  }, [destination, organization, crossHost, user?.org_id]);
  if (destination && !crossHost && organization.org_id === user?.org_id) return <Navigate replace to={destination} />;
  return <main className="grid min-h-screen place-items-center bg-[#f5f7f4] p-6"><section role="status" className="max-w-lg rounded-2xl bg-white p-8"><h1 className="text-2xl font-semibold">{error || membership.status === "error" ? "Organization unavailable" : membership.status === "ready" && !organization ? "Organization workspace unavailable" : "Opening organization workspace"}</h1><p className="mt-3">{error || membership.status === "error" || (membership.status === "ready" && !organization) ? "Your active organization could not be authorized for this address. Contact your organization administrator or sign in again." : "Confirming your active organization before loading administration."}</p></section></main>;
}
